<template>
    <div>
        <div class="help-message" v-if="dataLoadFlag">Загрузка ...</div>
        <div class="help-message" v-else-if="!dataLoadFlag && Object.keys(productsSelectedCategory).length === 0">
            Нет продуктов.
        </div>
        <div v-else class="material-grid-container">
          <div v-for="(product, productUUID) in productsSelectedCategory" v-if="typeSelectedPlane === product.type && product.active" class="material-grid-list"
               @click="selectProduct(productUUID)">
            <div class="material-grid-three-element-img-container material-img-container"
                 v-bind:class="{'active-photo': productUUID === selectedProductUUID}">
              <img class="material-grid-three-element-img" :src="urlForPhoto(product.preview)"/>
            </div>
            <div class="material-grid-three-element-text">
              {{product.name}}
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import {bus} from "../../../vue_bus";

export default {
    name: "ProductsSidebar",
    props: {
        idSelectedCategory: {
            type: Number
        }
    },
    computed:{
        dataLoadFlag(){
            return this.$store.state.UI.products.dataLoadFlag;
        },
        productsSelectedCategory(){
            return this.$store.getters["UI/products/PRODUCTS_SELECTED_CATEGORY"];
        },
        planeDesignSettings(){
            return this.$store.getters["active/PLANE_DESIGN_SETTINGS"];
        },
        selectedProductUUID(){
            if (this.planeDesignSettings && this.planeDesignSettings.uuidProduct){
                return this.planeDesignSettings.uuidProduct;
            } else {
                return null;
            }
        },
        typeSelectedPlane(){
            if (this.$store.state.route.params.facadeElement === "platband") {
                return "additional";
            }
            return this.$store.state.route.params.facadeElement;
        }
    },
    watch:{
        idSelectedCategory(newValue){
            this.$store.dispatch('UI/products/PRODUCT_CATEGORY_SELECTED', newValue);
        }
    },
    methods:{
        urlForPhoto(url) {
            return this.$store.getters[`projectConfiguration/GENERATE_URL`](url);
        },
        selectProduct(productUUID) {
            this.$store.dispatch('active/SET_PRODUCT_DESIGN_GROUP', productUUID);
            bus.$emit('productSelected', productUUID);
        },
    },
    mounted() {
        this.$store.dispatch('UI/products/PRODUCT_CATEGORY_SELECTED', this.idSelectedCategory);
    },
}
</script>

<style scoped>
    .material-grid-element {
        cursor: pointer;
    }
    .material-grid-three {
        display: grid;
        grid-template-columns: 70px 70px 70px;
        grid-column-gap: 10px;
        grid-row-gap: 10px;
    }

    .material-grid-list {
        display: grid;
        grid-template-columns: 70px auto;
        grid-column-gap: 10px;
        margin-bottom: 5px;
        cursor: pointer;
    }

    .material-grid-list:hover .material-grid-three-element-img-container{
        border: 2px solid #ACACAC;
    }

    .material-grid-three-element-img-container {
        width: 70px;
        height: 70px;
        border: 2px solid transparent;
        user-select: none;
    }

    .material-grid-three-element-img {
        max-width: 70px;
        max-height: 70px;
        object-fit: cover;
        width: 100%;
        height: 100%;
    }

    @media screen and (max-height: 800px) {
        .material-grid-three-element-text {
            font-size: 12px;
        }
    }

    @media screen and (min-height: 800px) {
        .material-grid-three-element-text {
            font-size: 14px;
        }
    }

    .material-grid-three-element-text {
        word-wrap: break-word;
        display: flex;
        align-items: center;
    }
</style>
